import { ListPromotionItemService } from 'application/services/list-promotion-items'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListPromotionItem = new ListPromotionItemService(api)
